<script>
import {mapState, mapGetters} from 'vuex';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import TrekLoading from '@/components/TrekLoading';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';

export default {
  name: 'CartSummary',
  components: {TrekButton, TrekLink, TrekLoading, Collapse, CollapseItem},

  props: {
    cartSummary: {
      type: Object,
      default: () => ({
        bikes: {},
        parts: {},
        total: '',
        hasAllocatedItems: false,
      }),
    },
    cartData: {
      type: Object,
      default: () => {},
    },
    calculatedFreight: {
      type: Object,
      default: () => {},
    },
    tabSelected: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    locale: {
      type: String,
      default: '',
    },
    hasReviewButton: Boolean,
    isPlaceOrderEnabled: {
      type: Boolean,
      default: true,
    },
    expanded: Boolean,
    isTaxableEmployee: Boolean,
  },

  data() {
    return {
      activeTabs: [],
      isSubmitting: false,
    };
  },

  computed: {
    bikeEstimatedShippingVisible() {
      if (this.calculatedFreight.bikes) return true;
      else if (Number(this.cartSummary.bikes.deliveryCost.replace(/[^0-9.-]+/g, '')) > 0) return true;
      else if (this.type === 'shipments') return false;
      else if (this.type === 'allocatedItems') return false;
      else return true;
    },

    bikesAreAvailable() {
      if (this.cartSummary.bikes && this.cartSummary.bikes.totalItems) {
        const totalItems = parseInt(this.cartSummary.bikes.totalItems);
        return !isNaN(totalItems) && totalItems > 0;
      }
      return false;
    },

    partsAreAvailable() {
      if (this.cartSummary.parts && this.cartSummary.parts.totalItems) {
        const totalItems = parseInt(this.cartSummary.parts.totalItems);
        return !isNaN(totalItems) && totalItems > 0;
      }
      return false;
    },

    cartIsEmpty() {
      return !this.bikesAreAvailable && !this.partsAreAvailable;
    },

    showReviewButton() {
      return !this.cartIsEmpty && this.bikesAreAvailable && this.partsAreAvailable;
    },

    showRecalculateLink() {
      return this.type === 'shipments' || this.type === 'allocatedItems';
    },

    highlightPartsMinAmount() {
      if (
        this.cartSummary &&
        this.cartSummary.parts &&
        this.cartSummary.parts.totalPrice &&
        this.cartSummary.parts.vendorMinimumDollarAmount
      ) {
        // Highlight total price if it's less than the minimum order amount
        return (
          Number(this.cartSummary.parts.totalPrice.replace(/[^0-9.-]+/g, '')) <
          Number(this.cartSummary.parts.vendorMinimumDollarAmount.replace(/[^0-9.-]+/g, ''))
        );
      }

      return false;
    },

    minDollarAmountPresent() {
      // When vendor min amount is set to null, backend sends a string amount of "0.0"
      // instead of null which causes the null logic checker on FE to be bypassed.
      // Therefore we need this new checker
      if (
        this.cartSummary &&
        this.cartSummary.parts &&
        this.cartSummary.parts.totalPrice &&
        this.cartSummary.parts.vendorMinimumDollarAmount &&
        this.cartSummary.parts.isVendorMinimumDollarAmountNull === false
      ) {
        return true;
      }
      return false;
    },

    ...mapState('cart', ['containers']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  mounted() {
    if (this.expanded) {
      this.activeTabs = ['cart-summary-bikes', 'cart-summary-parts'];
    }

    this.$emit('cart-summary-loaded');
  },

  methods: {
    showTax(type) {
      return this.cartSummary[type].totalTax && (this.locale === 'zh_CN' || this.isTaxableEmployee);
    },
    placeOrderAction() {
      this.isSubmitting = true;
    },
    activeTabsChange(tabs) {
      this.activeTabs = tabs;
    },

    checkoutDisabledCheck(event) {
      if (this.cartSummary != null && !this.cartSummary.isCheckoutAllowed) {
        event.preventDefault();
      }
    },
  },
};
</script>
